(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2165],{

/***/ 66565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CheckboxSVG = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.55491 13.1098C10.1751 13.1098 13.1098 10.1751 13.1098 6.55491C13.1098 2.93474 10.1751 0 6.55491 0C2.93474 0 0 2.93474 0 6.55491C0 10.1751 2.93474 13.1098 6.55491 13.1098ZM9.86117 5.0764C10.0949 4.76985 10.0358 4.33187 9.72927 4.09817C9.42271 3.86446 8.98474 3.92352 8.75103 4.23008L6.16635 7.62044L4.90602 6.10805C4.65924 5.81192 4.21912 5.7719 3.92299 6.01868C3.62685 6.26546 3.58684 6.70558 3.83362 7.00172L6.21491 9.85927L9.86117 5.0764Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxSVG);


/***/ }),

/***/ 32165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ marquee_cards_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(97005);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-component.scss.js

var StyledMarqueeCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qqami0"
})("gap:20px;");

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-product-card/marquee-product-card.scss.js




var CARD_BACKGROUND_COLOR = "#343751";
var StyledMarqueeProductCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1q3yq40"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;width:420px;height:530px;background-color:", CARD_BACKGROUND_COLOR, ";margin:0 20px;border-radius:12px;position:relative;overflow:hidden;.picture-wrapper{display:flex;justify-content:center;padding:4px;.picture-component{display:flex;img{border-radius:8px;width:100%;}}}.card-content{position:absolute;top:75%;height:40%;width:420px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;background-color:", CARD_BACKGROUND_COLOR, ";.title-wrapper{margin:20px 0 20px 20px;}.use-cases-wrapper{display:flex;flex-wrap:wrap;gap:12px;padding:0 0 20px 20px;.use-case{display:flex;gap:4px;align-items:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}.product-logo-wrapper{padding-bottom:20px;padding-left:20px;.recommended-product-text{.paragraph-wrapper .paragraph-body{font-size:0.75rem;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}.picture-component{display:flex;img{height:30px;}}}.seperator-line{height:1px;background-color:", colors/* default.asphalt */.Z.asphalt, ";}.product-signup-wrapper{display:flex;padding:20px 10px 20px 20px;}&.up{animation:slide-up 0.5s ease-in-out forwards;}&.down{animation:slide-down 0.5s ease-in-out forwards;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){width:360px;height:460px;margin:0 16px;.card-content{width:360px;.title-wrapper{margin:12px 0 12px 20px;}.use-cases-wrapper{padding:0 0 12px 20px;width:360px;.use-case{font-size:0.75rem;}}.product-signup-wrapper{padding:16px 10px 16px 20px;}}}@keyframes slide-up{0%{top:75%;}100%{top:45%;}}@keyframes slide-down{0%{top:45%;}100%{top:75%;}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-card/checkbox-icon.js
var checkbox_icon = __webpack_require__(66565);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-product-card/consts.js



var _obj;
var PRODUCT_ID_TO_LOGO = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/NaamaGros/Teams%20slider/wm_logo_l.png"), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/NaamaGros/Teams%20slider/crm_logo.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/NaamaGros/Teams%20slider/dev_logo.png"), _obj);
var _obj1;
var PRODUCT_ID_TO_COLOR = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.WORK_OS_IRIS_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), _obj1);
var _obj2;
var BUTTON_CONFIG_BY_PRODUCT = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, {
    signupProductId: products/* WORK_MANAGEMENT_PRODUCT_ID */.py
}), (0,_define_property/* default */.Z)(_obj2, products/* CRM_PRODUCT_ID */.$, {
    signupProductId: products/* CRM_PRODUCT_ID */.$
}), (0,_define_property/* default */.Z)(_obj2, products/* DEV_PRODUCT_ID */.xi, {
    signupProductId: products/* DEV_PRODUCT_ID */.xi
}), _obj2);

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-product-card/marquee-product-card.js
function marquee_product_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_product_card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var MarqueeProductCard = function(props) {
    var card = props.card;
    var cardAsset = card.cardAsset, titleText = card.titleText, useCases = card.useCases, productType = card.productType, cardLogoAsset = card.cardLogoAsset;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(false), isHoverTransition = ref1[0], setIsHoverTransition = ref1[1];
    var handleMouseEnter = function() {
        setIsHovered(true);
        setIsHoverTransition(false);
    };
    var handleMouseLeave = function() {
        if (isHovered) setIsHoverTransition(true);
        setIsHovered(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMarqueeProductCard, {
        className: "marquee-product-card",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("card-content", {
                    up: isHovered,
                    down: isHoverTransition
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                            title: titleText,
                            titleColor: "white",
                            titleSize: button_component.XS
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function(param) {
                            var useCase = param.useCase;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                                    useCase
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-logo-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "recommended-product-text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                                    body: "Recommended product"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: cardLogoAsset || PRODUCT_ID_TO_LOGO[productType]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "seperator-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-signup-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({
                            buttonSize: button_component.XS
                        }, BUTTON_CONFIG_BY_PRODUCT[productType]), {
                            buttonColor: color_consts.WHITE_COLOR_NAME,
                            withButtonArrow: false
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var marquee_product_card = (MarqueeProductCard);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-component.js




var MarqueeCardsGridComponent = function(props) {
    var cards = props.cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMarqueeCardsGridComponent, {
        className: "marquee-cards-grid-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            speed: 50,
            pauseOnHover: true,
            children: cards.map(function(card) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(marquee_product_card, {
                    card: card
                });
            })
        })
    });
};
/* harmony default export */ var marquee_cards_grid_component = (MarqueeCardsGridComponent);


/***/ }),

/***/ 97005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), transparent);\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

}]);